export const KEY = "lib/Snackbar";
export const SnackbarSeverity = Object.freeze({
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
});
export const SNACKBAR_DEFAULT_SEVERITY = SnackbarSeverity.INFO;
